import { render, staticRenderFns } from "./TicketInboxContents.vue?vue&type=template&id=0fdf3b42&scoped=true"
import script from "./TicketInboxContents.vue?vue&type=script&lang=js"
export * from "./TicketInboxContents.vue?vue&type=script&lang=js"
import style0 from "./TicketInboxContents.vue?vue&type=style&index=0&id=0fdf3b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf3b42",
  null
  
)

export default component.exports